import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "./AxiosConfiguration";

const reportsSlice = createSlice({
  name: "reports",
  initialState: {},
  reducers: {},
});

export default reportsSlice.reducer;

// GET Report/GetSetupUtilProjectList
export const fetchSetupUtilProjectList = createAsyncThunk(
  "reports/fetchSetupUtilProjectList",
  async ({ projectId = 0, companyId = 0 } = {}) =>
    await apiRequest(
      "GET",
      `Report/GetSetupUtilProjectList?projectId=${projectId}&companyId=${companyId}`
    )
);

// POST Report/GetSetupUtilReportData
export const fetchSetupUtilReportData = createAsyncThunk(
  "reports/fetchSetupUtilReportData",
  async ({
    projID = 0,
    fromDate = "",
    toDate = "",
    start = 0,
    length = 10,
    sortColumn = 0,
    sortColumnDir = "asc",
    search = "",
    draw = "1",
    companyId = 0,
  } = {}) =>
    await apiRequest("POST", "Report/GetSetupUtilReportData", {
      ProjID: projID,
      FromDate: fromDate,
      ToDate: toDate,
      Start: start,
      Length: length,
      SortColumn: sortColumn,
      SortColumnDir: sortColumnDir,
      Search: search,
      Draw: draw,
      CompanyId: companyId,
    })
);


export const fetchSetupUtilDumpReport = createAsyncThunk(
  "reports/fetchSetupUtilDumpReport",
  async ({ fromDate = "", toDate = "", companyId = 0 } = {}) =>
    await apiRequest(
      "GET",
      `Report/GenerateSetupUtilReport?fromDate=${fromDate}&toDate=${toDate}&CompanyId=${companyId}`
    )
);

// ─── Shift Changeover ─────────────────────────────────────────────────────────

// GET Report/GetShiftChangeoverFacilityList
export const fetchShiftChangeoverFacilityList = createAsyncThunk(
  "reports/fetchShiftChangeoverFacilityList",
  async ({ companyId = 0 } = {}) =>
    await apiRequest(
      "GET",
      `Report/GetShiftChangeoverFacilityList?companyId=${companyId}`
    )
);

// POST Report/GetShiftChangeoverReportData
export const fetchShiftChangeoverReportData = createAsyncThunk(
  "reports/fetchShiftChangeoverReportData",
  async ({
    facID = 0,
    fromDate = "",
    toDate = "",
    start = 0,
    length = 25,
    sortColumn = 0,
    sortColumnDir = "asc",
    search = "",
    draw = "1",
    companyId = 0,
  } = {}) =>
    await apiRequest("POST", "Report/GetShiftChangeoverReportData", {
      FacID: facID,
      FromDate: fromDate,
      ToDate: toDate,
      Start: start,
      Length: length,
      SortColumn: sortColumn,
      SortColumnDir: sortColumnDir,
      Search: search,
      Draw: draw,
      CompanyId: companyId,
    })
);
